import { useNavigate } from "react-router-dom";
import { Sparkles, Gift, Briefcase, Heart } from "lucide-react";

export default function Events() {
  const navigate = useNavigate();

  return (
      <section style={styles.container}>
        <h1 style={styles.heading}>Event Planning</h1>
        <p style={styles.subheading}>
          Thoughtfully curated experiences for every occasion
        </p>

        <div style={styles.cards}>
          {events.map((event) => (
              <div
                  key={event.slug}
                  style={styles.card}
                  onClick={() => navigate(`/events/${event.slug}`)}
              >
                <div style={styles.icon}>{event.icon}</div>
                <h3 style={styles.cardTitle}>{event.title}</h3>
                <p style={styles.cardText}>{event.description}</p>
              </div>
          ))}
        </div>
      </section>
  );
}

const events = [
  {
    title: "Weddings",
    slug: "weddings",
    description: "Elegant, stress-free wedding planning",
    icon: <Heart size={22} />
  },
  {
    title: "Birthdays",
    slug: "birthdays",
    description: "Stylish celebrations tailored to you",
    icon: <Gift size={22} />
  },
  {
    title: "Corporate Events",
    slug: "corporate",
    description: "Professional events that impress",
    icon: <Briefcase size={22} />
  },
  {
    title: "Special Events",
    slug: "special",
    description: "Milestones, launches & custom occasions",
    icon: <Sparkles size={22} />
  }
];

const styles = {
  container: {
    padding: "100px 40px",
    backgroundColor: "#faf9f6",
    textAlign: "center",
    minHeight: "100vh"
  },

  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "34px",
    fontWeight: "400",
    color: "#111",
    marginBottom: "10px"
  },

  subheading: {
    fontSize: "15px",
    color: "#777",
    marginBottom: "70px"
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "26px",
    maxWidth: "1100px",
    margin: "0 auto"
  },

  card: {
    backgroundColor: "#ffffff",
    borderRadius: "18px",
    padding: "40px 30px",
    border: "1px solid rgba(200,180,170,0.35)",
    boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s ease"
  },

  icon: {
    color: "#c9b6ab",
    marginBottom: "16px"
  },

  cardTitle: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#111",
    marginBottom: "8px"
  },

  cardText: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.6"
  }
};
